import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import './index.css';
import {
  confirmCheque,
  getAgeingReportApi,
  getCommitment,
  getCreditOutstandingBalanceApi,
  getStateDistrictCity,
} from '../../../constants/apiCalls';
import { useNavigate } from 'react-router-dom';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import CreditLimit from '../../../Components/CreditLimit';
import PrimaryContact from '../../../Components/PrimaryContact';
import CropAcreage from '../../../Components/CropAcreage';
import Commitment from '../../../Components/Commitment';
import Competition from '../../../Components/Competition';
import AdvanceBusinessInfo from '../../../Components/AdvanceBusinessInfo/AdvanceBusinessInfo';
import BasicBusinessInformation from '../../../Components/BasicBusinessInformation/BasicBusinessInformation';
import ActiveOwner from '../../../Components/ActiveOwner/ActiveOwner';
import OtherOwners from '../../../Components/OtherOwners/OtherOwners';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import ConfirmNote from '../../../Components/ConfirmNote/ConfirmNote';
import OwnerInformation from '../../../Components/OwnerInformation/OwnerInformation';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';

const PreviewAppModal = ({
  modalPreview,
  showButtons,
  userId,
  isCreditLimitModal,
  notProposedCreditLimit,
  propShowDocument=false,
  reloadDealerList=()=>{},
  modalShow,
  setModal,
}) => {
  const [previewData, setPreviewData] = useState('');
  const [isMultipleUser, setIsMultipleUser] = useState(false);
  const [activeOwner, setActiveOwner] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedOwnerState, setSelectedOwnerState] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedOwnerDistrict, setSelectedOwnerDistrict] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedOwnerCity, setSelectedOwnerCity] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [isShowDocuments, setIsShowDocuments] = useState(propShowDocument);
  const [isShowCommitment, setIsShowCommitment] = useState(false);
  const [isShowCompetition, setIsShowCompetition] = useState(false);
  const [isShowEntireApp, setIsShowEntireApp] = useState(false);
  const [commitments, setCommitments] = useState('');
  const [creditOutstandingBalance, setCreditOutstandingBalance] = useState('');
  const [ageingData, setAgeingData] = useState('');

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      getCommitments(userId);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    setPreviewData(dealerObj);
    let filterActiveOwner = dealerObj && dealerObj.owners && dealerObj.owners.length > 0 ? dealerObj.owners.filter(val => val.is_primary_contact === true) : [];
    setActiveOwner(filterActiveOwner);
    getStatesData(
      dealerObj.pincode,
      dealerObj.state_id,
      dealerObj.district_id,
      dealerObj.city_id
    );
    if (dealerObj && dealerObj.owners && dealerObj.owners.length > 0) {
      getOwnerState(
        dealerObj.owners[0].pincode,
        dealerObj.owners[0].state_id,
        dealerObj.owners[0].district_id,
        dealerObj.owners[0].city_id
      );
    }
    if(dealerObj && dealerObj.dealer_code){
      getCreditOutstandingBalance();
      getAgeingReportData();
    }
  }, [dealerObj])

  const getCommitments = (id) => {
    if (id) {
      let payload = { user_id: id, page: 1, pagesize: 50, year: '' };
      getCommitment((res) => {
        const { success, data, error } = res;
        if (success === true) {
          for (let i = 0; i < data.length; i++) {
            setCommitments(data);
          }
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
      }, payload);
    }
  };

  const getCreditOutstandingBalance = () => {
    let payload = { customer: dealerObj.dealer_code };
    getCreditOutstandingBalanceApi((res) => {
      const { success, data, error } = res;
      if (success === true) {
        const resData = data && data.length > 0 ? data[0] : '';
        setCreditOutstandingBalance(resData);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const getAgeingReportData = () => {
    let payload = { customer: dealerObj.dealer_code };
    getAgeingReportApi((res) => {
      const { success, data, error } = res;
      if (success === true) {
        const resData = data && data.length > 0 ? data[0] : '';
        setAgeingData(resData);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const getStatesData = (pincode, editStateId, editDistrictId, cityId) => {
    if (pincode) {
      let payload = {
        pincode: pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if (success === true) {
          if (data.length > 0) {
            let allData = data;
            // state array
            let stateArr = [
              ...new Map(allData.map((m) => [m.state_id, m])).values(),
            ]; // remove duplicate state
            setSelectedState(stateArr);

            // District array
            let districtArr = [
              ...new Map(allData.map((m) => [m.district_id, m])).values(),
            ]; // remove duplicate district
            let filterDistrict = districtArr.filter(
              (elem) => elem.district_id === editDistrictId
            );
            setSelectedDistrict(filterDistrict);

            // city Arr
            let cityArr = [
              ...new Map(allData.map((m) => [m.city_id, m])).values(),
            ]; // remove duplicate City
            let filterCity = cityArr.filter((elem) => elem.city_id === cityId);
            setSelectedCity(filterCity);

            setIsloading(false);
          }
        } else if(success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
  };

  // owner info
  const getOwnerState = (pincode, stateId, districtId, cityId) => {
    if (pincode) {
      let payload = {
        pincode: pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if (success === true) {
          if (data.length > 0) {
            let allData = data;
            // state array
            let stateArr = [
              ...new Map(allData.map((m) => [m.state_id, m])).values(),
            ]; // remove duplicate state
            setSelectedOwnerState(stateArr);

            // District array
            let districtArr = [
              ...new Map(allData.map((m) => [m.district_id, m])).values(),
            ]; // remove duplicate district
            let filterDistrict = districtArr.filter(
              (elem) => elem.district_id === districtId
            );
            setSelectedOwnerDistrict(filterDistrict);

            // city Arr
            let cityArr = [
              ...new Map(allData.map((m) => [m.city_id, m])).values(),
            ]; // remove duplicate City
            let filterCity = cityArr.filter((elem) => elem.city_id === cityId);
            setSelectedOwnerCity(filterCity);

            setIsloading(false);
          }
        } else if(success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleOwner = (e, val) => {
    setIsMultipleUser(!isMultipleUser);
  };

  const handleDocuments = (e) => {
    setIsShowDocuments(!isShowDocuments);
    if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleCommitment = (e) => {
    setIsShowCommitment(!isShowCommitment);
    if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleCompetition = (e) => {
    setIsShowCompetition(!isShowCompetition);
    if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleEnteireApp = (e) => {
    setIsShowEntireApp(!isShowEntireApp);
    if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    }
  };

  const handleOrderHistory = () => {
    navigate(`/order/order-summary/mtd/${userId}`);
  };

  const handleMeetingHistory = () => {
    navigate(`/meeting/meeting-history/mtd/${userId}`);
  };

  const submitConfirmCheque=async ()=>{
    try {
      setIsloading(true);
      const response= await confirmCheque({dealer_id:previewData.dealer_id,is_confirm_cheques:true})
      setIsloading(false);
    if(response.success){
      ModalService.openAlert('', 'Cheque Confirmed Successfully', 'success');
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
      reloadDealerList();
    }else{
      ModalService.openAlert('', handleErrorMessage(response.error[0].message), 'error');
    }
    } catch (error) {
      setIsloading(false);
      ModalService.openAlert('', handleErrorMessage(error.message), 'error'); 
    }

  }
  console.log('previewappmodal', activeOwner)
  return (
    <div id='PreviewAppModal'>
      {isLoading && <CustomSpinner />}
      {modalPreview && (
        <Row className='noprint'>
          <Col md={10}>
            <Breadcrumbs title='' />
          </Col>
          <Col md={2}>
            <Button
              onClick={() => navigate('/pages/verify-n-submit')}
              className='back-button'
            >
              Back
            </Button>
          </Col>
        </Row>
      )}
      {isCreditLimitModal ? (
        <CreditLimit
          userId={userId}
          isShowEntireApp={isShowEntireApp}
          showButtons={showButtons}
          previewData={previewData}
          handleDocuments={handleDocuments}
          handleCommitment={handleCommitment}
          handleCompetition={handleCompetition}
          handleEnteireApp={handleEnteireApp}
          handleOrderHistory={handleOrderHistory}
          handleMeetingHistory={handleMeetingHistory}
          isShowCompetition={isShowCompetition}
          isShowCommitment={isShowCommitment}
          isShowDocuments={isShowDocuments}
          activeOwner={activeOwner}
          creditOutstandingBalance={creditOutstandingBalance}
          ageingData={ageingData}
        />
      ) : (
        <div style={{ background: '#fff', marginBottom: '5px' }}>
          <OwnerInformation
            userId={userId}
            activeOwner={activeOwner}
            previewData={previewData}
            selectedOwnerCity={selectedOwnerCity}
          />
          {previewData && <hr width='98%' color='#000' />}
          <CreditLimit
            isShowEntireApp={isShowEntireApp}
            isShowCompetition={isShowCompetition}
            isShowCommitment={isShowCommitment}
            isShowDocuments={isShowDocuments}
            notProposedCreditLimit={notProposedCreditLimit}
            userId={userId}
            showButtons={showButtons}
            previewData={previewData}
            handleDocuments={handleDocuments}
            handleCommitment={handleCommitment}
            handleCompetition={handleCompetition}
            handleEnteireApp={handleEnteireApp}
            handleOrderHistory={handleOrderHistory}
            handleMeetingHistory={handleMeetingHistory}
            activeOwner={activeOwner}
            creditOutstandingBalance={creditOutstandingBalance}
            ageingData={ageingData}
          />
        </div>
      )}
      {isShowEntireApp && (
        <div>
          {' '}
          <div className='pt-3'>
            {' '}
            <BasicBusinessInformation
              userId={userId}
              previewData={previewData}
              activeOwner={activeOwner}
              selectedCity={selectedCity}
              selectedDistrict={selectedDistrict}
              selectedState={selectedState}
            />
          </div>
          {/* crop acreages */}
          <CropAcreage userId={userId} previewData={previewData} />
          {/* advance business information */}
          <AdvanceBusinessInfo userId={userId} previewData={previewData} />
          <Commitment
            userId={userId}
            previewData={commitments}
            previewAllData={previewData}
          />
          {/* Businesss Insights */}
          <Competition userId={userId} previewData={previewData} />
          <OtherOwners
            userId={userId}
            previewData={previewData}
            isMultipleUser={isMultipleUser}
            selectedOwnerCity={selectedOwnerCity}
            selectedOwnerDistrict={selectedOwnerDistrict}
            selectedOwnerState={selectedOwnerState}
            handleOwner={handleOwner}
          />
          <ActiveOwner
            userId={userId}
            activeOwner={activeOwner}
            previewData={previewData}
            isMultipleUser={isMultipleUser}
            selectedOwnerCity={selectedOwnerCity}
            selectedOwnerDistrict={selectedOwnerDistrict}
            selectedOwnerState={selectedOwnerState}
            handleOwner={handleOwner}
          />
          <ConfirmNote
            isShowTmConfirmationNote={true}
            previewData={previewData}
          />
          {/* Primary Contact Information */}
          <PrimaryContact userId={userId} previewData={previewData} />{' '}
        </div>
      )}
      {isShowCompetition && (
        <Competition userId={userId} previewData={previewData} />
      )}
      {isShowCommitment && (
        <Commitment
          userId={userId}
          previewData={commitments}
          previewAllData={previewData}
        />
      )}
      {isShowDocuments && (
        <AdvanceBusinessInfo userId={userId} previewData={previewData} submitConfirmCheque={submitConfirmCheque}/>
      )}
    </div>
  );
};

export default React.memo(PreviewAppModal);
